var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.notificationStatus == 1)?_c('div',{staticClass:"item",on:{"click":_vm.requestNotification}},[_c('i',{staticClass:"la la-bell font-h3"}),_c('h6',{staticClass:"flex-1 mb-0 px-10"},[_vm._v("Enable desktop notifications")]),_vm._m(0),_c('span',{staticClass:"shimmer"})]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-round bg-primary"},[_c('i',{staticClass:"la la-mouse-pointer"})])
}]

export { render, staticRenderFns }